export default __webpack_public_path__ + "static/media/chicken-strips.00fb2b85.jpg";